var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13.25h-1.063v-3.5a2 2 0 00-2-2h-3.874a2 2 0 00-2 2v3.5H9a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h10a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zm-4.563 3.703v.828a.125.125 0 01-.124.125h-.626a.125.125 0 01-.124-.125v-.828a.75.75 0 11.874 0zm2.376-3.703h-5.625v-3.5c0-.483.392-.875.874-.875h3.876c.482 0 .874.392.874.875v3.5z",
    fill: "#DC4017"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#DC4017"
  })));
}
export default __webpack_public_path__ + "static/media/LockIcon.bb451512.svg";
export { SvgLockIcon as ReactComponent };